exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".content[data-v-6a2242ac]{padding:30px}.table[data-v-6a2242ac]{margin-top:30px}.fb[data-v-6a2242ac]{font-weight:700}.el-pagination[data-v-6a2242ac]{float:right;margin:20px 0;padding:0}.el-icon-question[data-v-6a2242ac]{font-size:16px}", ""]);

// exports
